module.exports = __webpack_public_path__ + "static/img/tab_img.41d50bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Upload/tab_img.png
// module id = em8u
// module chunks = 19